import { IProduct } from '../Model/Questionnaire'
import { numOr0 } from './NumberHelper'
import * as _ from 'lodash'

export default class ProductHelper {
    public static convertToString(products: Array<IProduct>): string {
        return products.map((x: IProduct) =>
            `id: ${x.id} name: ${x.name} count: ${x.count} price: ${x.price} externalKey: ${x.externalKey}`)
            .join(' | ')
    }
}

export function getProductsSum(products: Array<IProduct>): number {
    if (!products || !products.length) {
        return 0
    }

    return _.round(
        products!
            .map((x: IProduct) => x.price * x.count)!
            .reduce(
                (a: number, b: number) => {
                    return numOr0(a) + numOr0(b)
                }),
        2
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/ProductHelper.ts